<template>
  <div class="mobile-menu-wrapper" :class="{open: menuOpen}">
    <div class="mobile-menu">
      <ul class="menu">
        <template v-for="item in menu">
          <li :key="`menu-item-${item.id}`"
              class="menu-item"
              :data-menuid="`${item.id}`"
              :data-submenu="`${item.menuParent}`"
              :class="{ 'active': item.isActive }">
            <a v-if="item.forceRegularLink || item.external || isIE10"
               :href="item.url"
               class="menu-link"
               :target="item.forceRegularLink ? '':'_blank'">
              {{ item.title }}
            </a>
            <router-link v-else
                         @click="closeMenu"
                         class="menu-link"
                         :to="item.url">
              {{ item.title }}
            </router-link>
          </li>
        </template>
        <li class="lease-address">
          <font-awesome-icon :icon="icon"/>
          <a class="map-lease map-link" v-if="linkAddress" :href="linkAddress" target="_blank" v-html="address"></a>
          <span v-else v-html="address"></span>
        </li>
      </ul>
    </div>
    <div class="mobile-menu-footer">
      <highlight-button v-if="buttons"
                        v-for="(button, index) in buttons"
                        :key="index"
                        v-bind="button"
      />
    </div>
  </div>
</template>

<script>
import MenuMixin from './mixin.menu'
import HighlightButton from './HighlightButton'

export default {
  name: "HeaderMenuMobile",
  mixins: [MenuMixin],
  components: {HighlightButton},
  props: {
    menuOpen: {
      type: Boolean,
      default: false,
    },
    address: String,
    linkAddress: String,
    icon: Object,
    buttons: Array,
  },
  methods: {
    closeMenu() {
      this.$emit('closeMenu');
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-menu-wrapper {
  position: fixed;
  background-color: $color3;
  width: 100vw;
  min-height: 100vh;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  pointer-events: none;
  transition: all .3s ease-in-out;

  .mobile-menu {
    padding-bottom: 50px;
    padding-left: 30px;
    padding-right: 30px;
  }

  &.open {
    opacity: 1;
    pointer-events: all;
  }

  .menu {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      line-height: 28px;
      margin-bottom: 15px
    }

    a {
      font-weight: $font-weight--semibold;
      font-size: 28px;
      text-decoration: none;
      color: $color1;
    }
  }

  .lease-address {
    font-size: 16px;
    margin-top: 35px;

    a {
      font-size: 16px;
    }


    svg {
      font-size: 25px;
    }
  }
}

.mobile-menu-footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  display: flex;
  background-color: $color1;
  justify-content: center;

  /deep/ {
    .highlight-button {
      position: relative;

      &.light {
        background-color: #E1E1E2;
      }
    }

    .button {

      @media (max-width: 600px) {
        width: calc(100% / 3);
      }

      &:first-child {
        .highlight-button::after {
          content: "";
          height: 70%;
          width: 1px;
          background-color: #fff;
          right: 0;
          left: auto;
          top: 50%;
          transform: translateY(-50%);
          position: absolute;
        }
      }
    }
  }
}


</style>
